import axios from "axios";
axios.defaults.baseURL =
  process.env.REACT_APP_BASE_URL ||
  "https://dashboard-club.ocamsclub.com/api/v1";
axios.defaults.headers.common["Content-Type"] = "application/json";

export default axios;
